import { isNative } from './platform';

export async function lightTap() {
  if (!isNative()) return;
  try {
    const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch (err) {
    console.warn('Haptics failed:', err);
  }
}
